import { TreeDataNode } from "antd";

export const dataTypeTreeDataForConvertibleInstruments: TreeDataNode[] = [
  {
    title: "Issuance Date",
    key: "Convertible Instruments_Issuance Date",
    children: [
      { title: "Note 1", key: "Convertible Instruments_Issuance Date_Note 1", isLeaf: true },
      { title: "Note 2", key: "Convertible Instruments_Issuance Date_Note 2", isLeaf: true },
      { title: "Note 3", key: "Convertible Instruments_Issuance Date_Note 3", isLeaf: true },
      { title: "Note 4", key: "Convertible Instruments_Issuance Date_Note 4", isLeaf: true },
      { title: "Note 5", key: "Convertible Instruments_Issuance Date_Note 5", isLeaf: true },
    ],
  },
  {
    title: "Maturity Date",
    key: "Convertible Instruments_Maturity Date",
    children: [
      { title: "Note 1", key: "Convertible Instruments_Maturity Date_Note 1", isLeaf: true },
      { title: "Note 2", key: "Convertible Instruments_Maturity Date_Note 2", isLeaf: true },
      { title: "Note 3", key: "Convertible Instruments_Maturity Date_Note 3", isLeaf: true },
      { title: "Note 4", key: "Convertible Instruments_Maturity Date_Note 4", isLeaf: true },
      { title: "Note 5", key: "Convertible Instruments_Maturity Date_Note 5", isLeaf: true },
    ],
  },
  {
    title: "Principle Amount Outstanding",
    key: "Convertible Instruments_Principle Amount Outstanding",
    children: [
      { title: "Note 1", key: "Convertible Instruments_Principle Amount Outstanding_Note 1", isLeaf: true },
      { title: "Note 2", key: "Convertible Instruments_Principle Amount Outstanding_Note 2", isLeaf: true },
      { title: "Note 3", key: "Convertible Instruments_Principle Amount Outstanding_Note 3", isLeaf: true },
      { title: "Note 4", key: "Convertible Instruments_Principle Amount Outstanding_Note 4", isLeaf: true },
      { title: "Note 5", key: "Convertible Instruments_Principle Amount Outstanding_Note 5", isLeaf: true },
    ],
  },
  {
    title: "Principle Value Per Note",
    key: "Convertible Instruments_Principle Value Per Note",
    children: [
      { title: "Note 1", key: "Convertible Instruments_Principle Value Per Note_Note 1", isLeaf: true },
      { title: "Note 2", key: "Convertible Instruments_Principle Value Per Note_Note 2", isLeaf: true },
      { title: "Note 3", key: "Convertible Instruments_Principle Value Per Note_Note 3", isLeaf: true },
      { title: "Note 4", key: "Convertible Instruments_Principle Value Per Note_Note 4", isLeaf: true },
      { title: "Note 5", key: "Convertible Instruments_Principle Value Per Note_Note 5", isLeaf: true },
    ],
  },
  {
    title: "Base Conversion Ratio",
    key: "Convertible Instruments_Base Conversion Ratio",
    children: [
      { title: "Note 1", key: "Convertible Instruments_Base Conversion Ratio_Note 1", isLeaf: true },
      { title: "Note 2", key: "Convertible Instruments_Base Conversion Ratio_Note 2", isLeaf: true },
      { title: "Note 3", key: "Convertible Instruments_Base Conversion Ratio_Note 3", isLeaf: true },
      { title: "Note 4", key: "Convertible Instruments_Base Conversion Ratio_Note 4", isLeaf: true },
      { title: "Note 5", key: "Convertible Instruments_Base Conversion Ratio_Note 5", isLeaf: true },
    ],
  },
  {
    title: "Implicit Strike Price",
    key: "Convertible Instruments_Implicit Strike Price",
    children: [
      { title: "Note 1", key: "Convertible Instruments_Implicit Strike Price_Note 1", isLeaf: true },
      { title: "Note 2", key: "Convertible Instruments_Implicit Strike Price_Note 2", isLeaf: true },
      { title: "Note 3", key: "Convertible Instruments_Implicit Strike Price_Note 3", isLeaf: true },
      { title: "Note 4", key: "Convertible Instruments_Implicit Strike Price_Note 4", isLeaf: true },
      { title: "Note 5", key: "Convertible Instruments_Implicit Strike Price_Note 5", isLeaf: true },
    ],
  },
  {
    title: "Fixed Coupon",
    key: "Convertible Instruments_Fixed Coupon",
    children: [
      { title: "Note 1", key: "Convertible Instruments_Fixed Coupon_Note 1", isLeaf: true },
      { title: "Note 2", key: "Convertible Instruments_Fixed Coupon_Note 2", isLeaf: true },
      { title: "Note 3", key: "Convertible Instruments_Fixed Coupon_Note 3", isLeaf: true },
      { title: "Note 4", key: "Convertible Instruments_Fixed Coupon_Note 4", isLeaf: true },
      { title: "Note 5", key: "Convertible Instruments_Fixed Coupon_Note 5", isLeaf: true },
    ],
  },
  {
    title: "Hedge Description",
    key: "Convertible Instruments_Hedge Description",
    children: [
      { title: "Note 1", key: "Convertible Instruments_Hedge Description_Note 1", isLeaf: true },
      { title: "Note 2", key: "Convertible Instruments_Hedge Description_Note 2", isLeaf: true },
      { title: "Note 3", key: "Convertible Instruments_Hedge Description_Note 3", isLeaf: true },
      { title: "Note 4", key: "Convertible Instruments_Hedge Description_Note 4", isLeaf: true },
      { title: "Note 5", key: "Convertible Instruments_Hedge Description_Note 5", isLeaf: true },
    ],
  },
  {
    title: "Capped Call",
    key: "Convertible Instruments_Capped Call",
    children: [
      {
        title: "Lower Strike Price",
        key: "Convertible Instruments_Capped Call_Lower Strike Price",
        children: [
          { title: "Note 1", key: "Convertible Instruments_Capped Call_Lower Strike Price_Note 1", isLeaf: true },
          { title: "Note 2", key: "Convertible Instruments_Capped Call_Lower Strike Price_Note 2", isLeaf: true },
          { title: "Note 3", key: "Convertible Instruments_Capped Call_Lower Strike Price_Note 3", isLeaf: true },
          { title: "Note 4", key: "Convertible Instruments_Capped Call_Lower Strike Price_Note 4", isLeaf: true },
          { title: "Note 5", key: "Convertible Instruments_Capped Call_Lower Strike Price_Note 5", isLeaf: true },
        ],
      },
      {
        title: "Upper Strike Price",
        key: "Convertible Instruments_Capped Call_Upper Strike Price",
        children: [
          { title: "Note 1", key: "Convertible Instruments_Capped Call_Upper Strike Price_Note 1", isLeaf: true },
          { title: "Note 2", key: "Convertible Instruments_Capped Call_Upper Strike Price_Note 2", isLeaf: true },
          { title: "Note 3", key: "Convertible Instruments_Capped Call_Upper Strike Price_Note 3", isLeaf: true },
          { title: "Note 4", key: "Convertible Instruments_Capped Call_Upper Strike Price_Note 4", isLeaf: true },
          { title: "Note 5", key: "Convertible Instruments_Capped Call_Upper Strike Price_Note 5", isLeaf: true },
        ],
      },
      {
        title: "Number of Underlying Shares",
        key: "Convertible Instruments_Capped Call_Number of Underlying Shares",
        children: [
          { title: "Note 1", key: "Convertible Instruments_Capped Call_Number of Underlying Shares_Note 1", isLeaf: true },
          { title: "Note 2", key: "Convertible Instruments_Capped Call_Number of Underlying Shares_Note 2", isLeaf: true },
          { title: "Note 3", key: "Convertible Instruments_Capped Call_Number of Underlying Shares_Note 3", isLeaf: true },
          { title: "Note 4", key: "Convertible Instruments_Capped Call_Number of Underlying Shares_Note 4", isLeaf: true },
          { title: "Note 5", key: "Convertible Instruments_Capped Call_Number of Underlying Shares_Note 5", isLeaf: true },
        ],
      },
    ],
  },
  {
    title: "Bond, Hedge and Warrant",
    key: "Convertible Instruments_Bond, Hedge and Warrant",
    children: [
      {
        title: "Call Option Strike Price",
        key: "Convertible Instruments_Bond, Hedge and Warrant_Call Option Strike Price",
        children: [
          { title: "Note 1", key: "Convertible Instruments_Bond, Hedge and Warrant_Call Option Strike Price_Note 1", isLeaf: true },
          { title: "Note 2", key: "Convertible Instruments_Bond, Hedge and Warrant_Call Option Strike Price_Note 2", isLeaf: true },
          { title: "Note 3", key: "Convertible Instruments_Bond, Hedge and Warrant_Call Option Strike Price_Note 3", isLeaf: true },
          { title: "Note 4", key: "Convertible Instruments_Bond, Hedge and Warrant_Call Option Strike Price_Note 4", isLeaf: true },
          { title: "Note 5", key: "Convertible Instruments_Bond, Hedge and Warrant_Call Option Strike Price_Note 5", isLeaf: true },
        ],
      },
      {
        title: "Call Option Number of Shares",
        key: "Convertible Instruments_Bond, Hedge and Warrant_Call Option Number of Shares",
        children: [
          { title: "Note 1", key: "Convertible Instruments_Bond, Hedge and Warrant_Call Option Number of Shares_Note 1", isLeaf: true },
          { title: "Note 2", key: "Convertible Instruments_Bond, Hedge and Warrant_Call Option Number of Shares_Note 2", isLeaf: true },
          { title: "Note 3", key: "Convertible Instruments_Bond, Hedge and Warrant_Call Option Number of Shares_Note 3", isLeaf: true },
          { title: "Note 4", key: "Convertible Instruments_Bond, Hedge and Warrant_Call Option Number of Shares_Note 4", isLeaf: true },
          { title: "Note 5", key: "Convertible Instruments_Bond, Hedge and Warrant_Call Option Number of Shares_Note 5", isLeaf: true },
        ],
      },
      {
        title: "Warrant Strike Price",
        key: "Convertible Instruments_Bond, Hedge and Warrant_Warrant Strike Price",
        children: [
          { title: "Note 1", key: "Convertible Instruments_Bond, Hedge and Warrant_Warrant Strike Price_Note 1", isLeaf: true },
          { title: "Note 2", key: "Convertible Instruments_Bond, Hedge and Warrant_Warrant Strike Price_Note 2", isLeaf: true },
          { title: "Note 3", key: "Convertible Instruments_Bond, Hedge and Warrant_Warrant Strike Price_Note 3", isLeaf: true },
          { title: "Note 4", key: "Convertible Instruments_Bond, Hedge and Warrant_Warrant Strike Price_Note 4", isLeaf: true },
          { title: "Note 5", key: "Convertible Instruments_Bond, Hedge and Warrant_Warrant Strike Price_Note 5", isLeaf: true },
        ],
      },
      {
        title: "Warrant Number of Shares",
        key: "Convertible Instruments_Bond, Hedge and Warrant_Warrant Number of Shares",
        children: [
          { title: "Note 1", key: "Convertible Instruments_Bond, Hedge and Warrant_Warrant Number of Shares_Note 1", isLeaf: true },
          { title: "Note 2", key: "Convertible Instruments_Bond, Hedge and Warrant_Warrant Number of Shares_Note 2", isLeaf: true },
          { title: "Note 3", key: "Convertible Instruments_Bond, Hedge and Warrant_Warrant Number of Shares_Note 3", isLeaf: true },
          { title: "Note 4", key: "Convertible Instruments_Bond, Hedge and Warrant_Warrant Number of Shares_Note 4", isLeaf: true },
          { title: "Note 5", key: "Convertible Instruments_Bond, Hedge and Warrant_Warrant Number of Shares_Note 5", isLeaf: true },
        ],
      },
    ],
  },
  {
    title: "Make-Whole",
    key: "Convertible Instruments_Make-Whole",
    children: [
      {
        title: "Table",
        key: "Convertible Instruments_Make-Whole_Table",
        children: [
          {
            title: "Note 1",
            key: "Convertible Instruments_Make-Whole_Table_Note 1",
            isLeaf: true,
          },
          {
            title: "Note 2",
            key: "Convertible Instruments_Make-Whole_Table_Note 2",
            isLeaf: true,
          },
          {
            title: "Note 3",
            key: "Convertible Instruments_Make-Whole_Table_Note 3",
            isLeaf: true,
          },
          {
            title: "Note 4",
            key: "Convertible Instruments_Make-Whole_Table_Note 4",
            isLeaf: true,
          },
          {
            title: "Note 5",
            key: "Convertible Instruments_Make-Whole_Table_Note 5",
            isLeaf: true,
          },
        ],
      },
    ],
  },
];
